import React, { useState, useEffect } from "react";
import "./shopItems.css";

import CarouselComponent from "../Carousel/CarouselComponent";
import SearchIcon from "../../../../images/icons/search.png";
import CategoryMenu from "../CategoryMenu/CategoryMenu";

import MobileList from "../MobileList/MobileList";

import { useAuth } from "../../../../contexts/AuthContext";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";

import Loader from "../../../commonComponents/Loader/Loader";
import { Link, useLocation } from "react-router-dom";
import Toolbar from "../Toolbar/Toolbar";

function useQuery() {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
}

export default function ShopItems() {
  const [productData, setProductData] = useState([]);
  const [activeCategory, setActiveCategory] = useState({
    primary: "",
    secendery: "",
  });

  const setSecendery = (string) => {
    setActiveCategory((old) => ({ ...old, secendery: string }));
  };

  const { currentUser } = useAuth();

  const query = useQuery();
  const mainCategory = query.get("category");

  useEffect(() => {
    fetch("https://api.redfoxcafe.ir/v1/main/products/", {
      method: "GET",
      headers: {
        "Authorization-Token":
          "Bearer " + (currentUser ? currentUser.access_token : ""),
      },
    })
      .then((response) => response.json())
      .then((d) => {
        const selectedProducts = d.data.filter(
          (val) => val.MainCatInEnglish === mainCategory
        )[0];
        setProductData(selectedProducts.data);
        setActiveCategory({
          primary: selectedProducts.MainCatName,
          secendery: selectedProducts.data[0].CategoryTitle,
        });
      });
  }, [currentUser]);

  const [searchText, setSearchText] = useState("");

  function handleSearchChange(e) {
    setSearchText(e.target.value);
  }

  const categories = productData.map((val) => {
    return {
      categoryTitle: val.CategoryTitle,
      categoryPicture: val.CategoryPicture,
    };
  });

  function getItems() {
    let items = [];
    if (searchText !== "") {
      for (let i = 0; i < productData.length; i++) {
        const matchedItems = productData[i].Products.filter((val) => {
          return val.ProductTitle.toLowerCase().includes(
            searchText.toLowerCase()
          );
        });

        items = [...items, ...matchedItems];
      }
    } else {
      const matchedItem = productData.find((val) => {
        return val.CategoryTitle === activeCategory.secendery;
      });

      items = matchedItem ? matchedItem.Products : [];
    }

    return items;
  }
  return (
    <div className="menu-container upper-container">
      {activeCategory.secendery === "" ? (
        <Loader />
      ) : (
        <>
          <Toolbar />
          <Link to="/" className="red-submit-btn return-to-categories">
            <FontAwesomeIcon icon={faArrowLeft} />
          </Link>
          <div className="upper-section">
            <div className="search-bar">
              <input
                type="text"
                placeholder="نوشیدنی مورد علاقت رو اینجا بنویس..."
                className="search-input"
                value={searchText}
                onChange={handleSearchChange}
              />
              <span className="search-icon">
                <img src={SearchIcon} alt="" />
              </span>
            </div>
            <div className="menu-categories">
              {productData.length !== 0 && (
                <CategoryMenu
                  active={activeCategory.secendery}
                  setActive={setSecendery}
                  data={categories}
                />
              )}
            </div>
          </div>

          <div className="main-menu">
            <div className="menu-title">
              {searchText === "" && (
                <>
                  <span className="category-name">
                    {activeCategory.primary}
                  </span>
                  <span className="category-desc">
                    {activeCategory.secendery}
                  </span>
                </>
              )}
              <span className="cafe-name">RED FOX</span>
              <span className="cafe-name-desc">Coffee Shop</span>
            </div>
            {productData.length !== 0 && (
              <>
                <CarouselComponent
                  menuItems={getItems()}
                  resetPositionOnChange={activeCategory.secendery}
                />
                <MobileList menuItems={getItems()} />
              </>
            )}
          </div>
        </>
      )}
    </div>
  );
}
